/**
 * Saborlista Analytics Wrapper
 * Provides a unified interface for sending events to Google Analytics (gtag) and Yandex Metrika (ym).
 */
(function(window) {
    'use strict';

    const SaborlistaAnalytics = {
        debug: false,
        
        /**
         * Initialize the analytics wrapper
         * @param {Object} options 
         */
        init: function(options) {
            this.debug = options.debug || false;
            if (this.debug) {
                console.log('[SaborlistaAnalytics] Initialized', options);
            }
        },

        /**
         * Send event to all active trackers
         * @param {string} eventName 
         * @param {Object} eventData 
         * @param {boolean} useGlobal Whether to enrich with global window.analyticsData
         */
        sendEvent: function(eventName, eventData, useGlobal = true) {
            const data = eventData || {};
            
            // Enrich with global analyticsData if available
            const enrichedData = useGlobal ? Object.assign({}, window.analyticsData || {}, data) : data;

            if (this.debug) {
                console.log(`[SaborlistaAnalytics] Event: ${eventName}`, enrichedData);
            }

            // 1. Google Analytics (gtag)
            if (typeof window.gtag === 'function') {
                window.gtag('event', eventName, enrichedData);
                if (this.debug) console.log(`[SaborlistaAnalytics] Sent to GA: ${eventName}`);
            }

            // 2. Yandex Metrika (ym)
            const metrikaId = (window.cmpConfig && window.cmpConfig.metrikaId) || (window.analyticsData && window.analyticsData.metrikaId);
            if (typeof window.ym === 'function' && metrikaId) {
                if (eventName === 'page_view') {
                    const pageReferer = data.page_referrer || document.referrer || window.location.href;
                    // For page_view, use 'hit' to record a new pageview in YM
                    window.ym(metrikaId, 'hit', data.page_location || window.location.href, {
                        title: data.page_title || document.title,
                        referer: pageReferer,
                        params: enrichedData
                    });
                    if (this.debug) console.log(`[SaborlistaAnalytics] Sent hit to YM (${metrikaId}): ${eventName}`);
                } else {
                    // ym(id, 'reachGoal', target, params)
                    window.ym(metrikaId, 'reachGoal', eventName, enrichedData);
                    // Also send as params for better reporting in Metrika
                    window.ym(metrikaId, 'params', { [eventName]: enrichedData });
                    
                    if (this.debug) console.log(`[SaborlistaAnalytics] Sent to YM (${metrikaId}): ${eventName}`);
                }
            }
        }
    };

    // Expose to global scope
    window.SaborlistaAnalytics = SaborlistaAnalytics;

    // Auto-initialize if saborlistaAnalytics global is present (passed from PHP)
    if (window.saborlistaAnalytics) {
        SaborlistaAnalytics.init(window.saborlistaAnalytics);
    }

})(window);
